module.exports = __webpack_public_path__ + "img/sxexhibition.7c83a022.jpg";